import BaseClient from './BaseClient';

class TeamsClient extends BaseClient {
    updateDetails(teamId, data) {
        return this.makeCoreApiRequest(`/settings/teams/${teamId}/name`, 'put', data);
    }

    getHubspotConnectionStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/hubspot/connection-status`);
    }

    disconnectHubspot(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/hubspot`, 'delete');
    }

    getJobberConnections(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/jobber/connections`);
    }

    disconnectJobber(teamId, vendorId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/jobber/${encodeURIComponent(vendorId)}`, 'delete');
    }

    getCalendlyConnectionStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/calendly/connection-status`);
    }

    disconnectCalendly(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/calendly`, 'delete');
    }

    getFtpPullStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull/status`);
    }

    getFtpPullConfig(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull`);
    }

    saveFtpPullConfig(teamId, config) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull`, 'post', config);
    }

    deleteFtpPullConfig(teamId, type) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull/${type}`, 'delete');
    }

    getFtpPullRuns(teamId, params) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/ftp-pull/runs`, 'get', null, params);
    }

    getAcuityConnectionStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/acuity/connection-status`);
    }

    disconnectAcuity(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/acuity`, 'delete');
    }

    getAmplitudeStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/amplitude/status`);
    }

    connectAmplitudeInbound(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/amplitude/inbound`, 'post');
    }

    disconnectAmplitudeInbound(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/amplitude/inbound`, 'delete');
    }

    connectAmplitudeOutbound(teamId, apiKey) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/amplitude/outbound`, 'post', {
            amplitude_api_key: apiKey,
        });
    }

    disconnectAmplitudeOutbound(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/amplitude/outbound`, 'delete');
    }

    getRevelStatus(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/revel/status`);
    }

    generateRevelWebhookUrl(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/revel/webhook-url`, 'post');
    }

    disconnectRevel(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/revel`, 'delete');
    }

    getCostVisibility(teamId) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/cost-visibility`);
    }

    updateCostVisibility(teamId, data) {
        return this.makeCoreApiRequest(`/api/v3/teams/${teamId}/cost-visibility`, 'put', data);
    }
}

export default new TeamsClient();
